import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { updateAddtionalInfo } from "../UpdateMonitoringInfo";
import { useDispatch, useSelector } from "react-redux";
import * as monitoringActions from "../../../../store/monitoringInfoService/actions";
import { getFlowByName } from "../../../../config/FlowName";
import * as NextStepFlowAction from "../../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../../store";
import { useTranslation } from "react-i18next";
import { Notification } from "../../../common/Notification";

interface IProps {
    refreshDataCallback(): void;
    setStatus: any;
    formData: any;
    personalData: any;
    activeStatus: any;
}

const AdditionalInfoForm = ({ refreshDataCallback, setStatus, formData, personalData, activeStatus }: IProps) => {
    const { t: tLang } = useTranslation();

    const isLoading = useSelector((state: ApplicationState) => (state.monitoringState ? state.monitoringState.isUpdatingAdditionalInfo : false));
    let duplicatePassport = false;
    let duplicateMedicalId = false;

    const { register, handleSubmit, errors, control, getValues } = useForm({
        mode: "onBlur",
        defaultValues: {
            driversLicence: formData.driversLicence["driver-licence"],
            passportPrimary: formData.passportPrimary,
            passports:
                formData && formData.passportPrimary && formData.passportPrimary.passport
                    ? [formData.passportPrimary, ...formData.additionlPassports]
                    : formData.additionlPassports,
            medicalIds:
                formData && formData.medicalInsurance && formData.medicalInsurance["medical-id"]
                    ? [formData.medicalInsurance, ...formData.additionalMedicalInsurance]
                    : formData.additionalMedicalInsurance,
            motherMaidenName: formData.motherMaidenName["mother-maiden"],
        },
    });

    const passportHandler = useFieldArray({
        control,
        name: "passports",
    });

    const medicalInsurenceHandler = useFieldArray({
        control,
        name: "medicalIds",
    });

    const dispatch = useDispatch();
    const monitoringInfoFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-ADDITIONAL-INFORMATION"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const updatingAdditionalInfoLoaderStatus = (status: boolean) => dispatch(monitoringActions.actionCreators.updatingAdditionalInfoLoaderStatus(status));

    const submit = (data: any) => {
        data.passports &&
            data.passports.length > 0 &&
            data.passports.forEach((passport: any) => {
                if (data.passports.filter((element: any) => element.passport === passport.passport).length > 1) {
                    duplicatePassport = true;
                    return;
                }
            });
        data.medicalIds &&
            data.medicalIds.length > 0 &&
            data.medicalIds.forEach((medicalId: any) => {
                if (data.medicalIds.filter((element: any) => element["medical-id"] == medicalId["medical-id"]).length > 1) {
                    duplicateMedicalId = true;
                    return;
                }
            });
        updatingAdditionalInfoLoaderStatus(true);
        updateAddtionalInfo(personalData, data, formData)
            .then((data: any) => {
                if (monitoringInfoFlow && monitoringInfoFlow.flowStepStatus !== "COMPLETED") {
                    completeGetStartedItem(monitoringInfoFlow.flowStepId, monitoringInfoFlow.flowName ? monitoringInfoFlow.flowName : " ");
                }
                setTimeout(() => {
                    refreshDataCallback();
                    updatingAdditionalInfoLoaderStatus(false);
                    setStatus(false);
                }, 3000);
                if (data.hasError) {
                    Notification({
                        type: "error",
                        title: "Error",
                        message: data.errors[0],
                        duration: 5,
                    });
                }
            })
            .catch(function (error) {
                setTimeout(() => {
                    refreshDataCallback();
                    updatingAdditionalInfoLoaderStatus(false);
                    setStatus(false);
                }, 3000);
            });
    };

    return (
        <div id="monitored-info-additional-info-form" className={`${isLoading && "loading"}`}>
            <form onSubmit={handleSubmit(submit)} id="monitored-info-additional-info-form-container">
                {activeStatus.isDriversLicenseActive && (
                    <div className={`form-row inline row ${errors["driversLicence"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-drivers-license">{tLang("additionalInformationWidget.label.dl")}</label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <input
                                aria-required="true"
                                type="text"
                                className="inputbox"
                                id="label-drivers-license"
                                placeholder={tLang("additionalInformationWidget.placeholder.dl")}
                                name="driversLicence"
                                maxLength={30}
                                ref={register({ pattern: /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF\*]+$/, minLength: 4, maxLength: 30 })}
                            />
                            {!!errors["driversLicence"] && !!errors["driversLicence"] && errors["driversLicence"]!.type === "required" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.dlRequired")}</span>
                            )}
                            {!!errors["driversLicence"] && !!errors["driversLicence"] && errors["driversLicence"]!.type === "pattern" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.dlPattern")}</span>
                            )}
                            {!!errors["driversLicence"] && !!errors["driversLicence"] && errors["driversLicence"]!.type === "minLength" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.dlMinlength")}</span>
                            )}
                            {!!errors["driversLicence"] && !!errors["driversLicence"] && errors["driversLicence"]!.type === "maxLength" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.dlMaxlength")}</span>
                            )}
                        </div>
                    </div>
                )}

                {activeStatus.isPassposrtMonitoringActive &&
                    passportHandler.fields.map((item, index) => {
                        return (
                            <div className={`form-row inline row ${errors["passports"] && errors["passports"][index] && "status-error"}`} key={item.id}>
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    {index === 0 ?
                                        <label htmlFor={`label-passport-${index}`}>{tLang("additionalInformationWidget.label.passport")}</label> :
                                        <label htmlFor={`label-passport-${index}`} className="hide-label">{tLang("additionalInformationWidget.label.passport")}{`${' '.repeat(index + 1)}`}</label>
                                    }
                                </div>
                                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                    <input
                                        aria-required="true"
                                        type="text"
                                        className={
                                            ([formData.passportPrimary, ...formData.additionlPassports].findIndex(
                                                (element: any) => element["passport"] === item["passport"]
                                            ) >= 0 &&
                                            item["passport"] !== "" &&
                                            item["passport"] !== undefined)
                                            ? "inputbox hide-input"
                                            : "inputbox"
                                        }
                                        id={`label-passport-${index}`}
                                        placeholder={tLang("additionalInformationWidget.placeholder.passport")}
                                        name={`passports[${index}].passport`}
                                        defaultValue={`${item!.passport}`} // make sure to set up defaultValue
                                        ref={register({
                                            pattern: /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF]+$/,
                                            minLength: 4,
                                            maxLength: 30,
                                            validate: (): boolean | string => {
                                                const passports = getValues().passports;
                                                const duplicate = passports.reduce((p: any, c: any) => {
                                                    if (c.passport === passports[index].passport) p++;
                                                    return p;
                                                }, 0);
                                                if (duplicate > 1) {
                                                    return "Duplicate Passport";
                                                }
                                                return true;
                                            },
                                        })}
                                        maxLength={30}
                                    />

                                    <span
                                        hidden={
                                            [formData.passportPrimary, ...formData.additionlPassports].findIndex(
                                                (element: any) => element["passport"] === item["passport"]
                                            ) < 0 &&
                                            item["passport"] !== "" &&
                                            item["passport"] !== undefined
                                        }
                                    >
                                        <p>
                                            {`${"*".repeat(item!.passport.substr(0, item!.passport.length - 4).length)}${item!.passport.substr(
                                                item!.passport.length - 4
                                            )}`}
                                        </p>
                                    </span>
                                    <div className="form-input-button">
                                        <button
                                            style={{
                                                marginTop:
                                                    [formData.passportPrimary, ...formData.additionlPassports].findIndex(
                                                        (element: any) => element["passport"] === item["passport"]
                                                    ) >= 0 && item["passport"] !== ""
                                                        ? -10
                                                        : 0,
                                            }}
                                            onClick={() => passportHandler.remove(index)}
                                            type="button"
                                            className="btn-default btn-icon-only btn-no-padding"
                                        >
                                            <span className="btn-icon">
                                                <em className="las la-trash-alt"></em>
                                            </span>
                                            <span className="btn-text">Remove Alternate Passport</span>
                                        </button>
                                    </div>
                                    {!!errors[`passports`] && !!errors[`passports`][index] && errors[`passports`][index]["passport"]!["type"] === "pattern" && (
                                        <span className="form-error">{tLang("additionalInformationWidget.validationMessage.passportPattern")}</span>
                                    )}
                                    {!!errors[`passports`] && !!errors[`passports`][index] && errors[`passports`][index]["passport"]!["type"] === "minLength" && (
                                        <span className="form-error">{tLang("additionalInformationWidget.validationMessage.passportMinlength")}</span>
                                    )}
                                    {!!errors[`passports`] && !!errors[`passports`][index] && errors[`passports`][index]["passport"]!["type"] === "maxLength" && (
                                        <span className="form-error">{tLang("additionalInformationWidget.validationMessage.passportMaxlength")}</span>
                                    )}
                                    {!!errors["passports"] && !!errors["passports"][index] && errors["passports"][index]!.passport!.type === "validate" && (
                                        <span className="form-error">{tLang("additionalInformationWidget.validationMessage.passportDuplicate")}</span>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                {activeStatus.isPassposrtMonitoringActive && passportHandler.fields.length < 5 && (
                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            {passportHandler.fields.length === 0 && <label htmlFor="label-passport">{tLang("additionalInformationWidget.label.passport")}</label>}
                        </div>
                        <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding"
                                onClick={() => {
                                    passportHandler.append({
                                        passport: "",
                                    });
                                }}
                            >
                                <span className="btn-icon">
                                    <em className="las la-plus"></em>
                                </span>
                                <span className="btn-text">{tLang("additionalInformationWidget.addPassportLinkText")}</span>
                            </button>
                        </div>
                    </div>
                )}
                {activeStatus.isMedicalIdMonitoringActive &&
                    medicalInsurenceHandler.fields.map((item, index) => {
                        return (
                            <div className={`form-row inline row ${errors["medicalIds"] && errors["medicalIds"][index] && "status-error"}`} key={item.id}>
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    {index === 0 ?
                                        <label htmlFor={`label-medical-${index}`}>{tLang("additionalInformationWidget.label.medicalInsurance")}</label> :
                                        <label htmlFor={`label-medical-${index}`} className="hide-label">{tLang("additionalInformationWidget.label.medicalInsurance")}{`${' '.repeat(index + 1)}`}</label>
                                        }
                                </div>
                                <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                    <input
                                        aria-required="true"
                                        type="text"
                                        className={
                                            ([formData.medicalInsurance, ...formData.additionalMedicalInsurance].findIndex(
                                                (element: any) => element["medical-id"] === item["medical-id"]
                                            ) >= 0 &&
                                                item["medical-id"] !== "" &&
                                                item["medical-id"] !== undefined)
                                                ? "inputbox hide-input"
                                                : "inputbox"
                                        }
                                        id={`label-medical-${index}`}
                                        placeholder={tLang("additionalInformationWidget.placeholder.medicalInsurance")}
                                        name={`medicalIds[${index}].medical-id`}
                                        defaultValue={`${item!["medical-id"]}`} // make sure to set up defaultValue
                                        ref={register({
                                            pattern: /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF]+$/,
                                            minLength: 4,
                                            maxLength: 30,
                                            validate: (): boolean | string => {
                                                const medicalIds = getValues().medicalIds;
                                                const duplicate = medicalIds.reduce((p: any, c: any) => {
                                                    if (c["medical-id"].toLowerCase() === medicalIds[index]["medical-id"].toLowerCase()) p++;
                                                    return p;
                                                }, 0);
                                                if (duplicate > 1) {
                                                    return "Duplicate MedicalId";
                                                }
                                                return true;
                                            },
                                        })}
                                        maxLength={30}
                                    />
                                    <span
                                        hidden={
                                            [formData.medicalInsurance, ...formData.additionalMedicalInsurance].findIndex(
                                                (element: any) => element["medical-id"] === item["medical-id"]
                                            ) < 0 &&
                                            item["medical-id"] !== "" &&
                                            item["medical-id"] !== undefined
                                        }
                                    >
                                        <p>
                                            {`${"*".repeat(item!["medical-id"].substr(0, item!["medical-id"].length - 4).length)}${item!["medical-id"].substr(
                                                item!["medical-id"].length - 4
                                            )}`}
                                        </p>
                                    </span>

                                    <div className="form-input-button">
                                        <button
                                            style={{
                                                marginTop:
                                                    [formData.medicalInsurance, ...formData.additionalMedicalInsurance].findIndex(
                                                        (element: any) => element["medical-id"] === item["medical-id"]
                                                    ) >= 0 && item["medical-id"] !== ""
                                                        ? -10
                                                        : 0,
                                            }}
                                            onClick={() => medicalInsurenceHandler.remove(index)}
                                            type="button"
                                            className="btn-default btn-icon-only btn-no-padding"
                                        >
                                            <span className="btn-icon">
                                                <em className="las la-trash-alt"></em>
                                            </span>
                                            <span className="btn-text">Remove Alternate Medical Insurance</span>
                                        </button>
                                    </div>
                                    {!!errors[`medicalIds`] &&
                                        !!errors[`medicalIds`][index] &&
                                        errors[`medicalIds`][index]!["medical-id"]["type"] === "pattern" && (
                                            <span className="form-error">{tLang("additionalInformationWidget.validationMessage.medicalIdPattern")}</span>
                                        )}
                                    {!!errors[`medicalIds`] &&
                                        !!errors[`medicalIds`][index] &&
                                        errors[`medicalIds`][index]!["medical-id"]["type"] === "minLength" && (
                                            <span className="form-error">{tLang("additionalInformationWidget.validationMessage.medicalIdMinlength")}</span>
                                        )}
                                    {!!errors[`medicalIds`] &&
                                        !!errors[`medicalIds`][index] &&
                                        errors[`medicalIds`][index]!["medical-id"]["type"] === "maxLength" && (
                                            <span className="form-error">{tLang("additionalInformationWidget.validationMessage.medicalIdMaxlength")}</span>
                                        )}
                                    {!!errors["medicalIds"] &&
                                        !!errors["medicalIds"][index] &&
                                        errors["medicalIds"][index]!["medical-id"]["type"] === "validate" && (
                                        <span className="form-error">{tLang("additionalInformationWidget.validationMessage.medicalIdDuplicate")}</span>
                                        )}
                                </div>
                            </div>
                        );
                    })}
                {activeStatus.isMedicalIdMonitoringActive && medicalInsurenceHandler.fields.length < 10 && (
                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            {medicalInsurenceHandler.fields.length === 0 && (
                                <label htmlFor="label-passport">{tLang("additionalInformationWidget.label.medicalInsurance")}</label>
                            )}
                        </div>
                        <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding"
                                onClick={() => {
                                    medicalInsurenceHandler.append({
                                        "medical-id": "",
                                    });
                                }}
                            >
                                <span className="btn-icon">
                                    <em className="las la-plus"></em>
                                </span>
                                <span className="btn-text">{tLang("additionalInformationWidget.addMedicalIdLinkText")}</span>
                            </button>
                        </div>
                    </div>
                )}
                {activeStatus.isMotherMaidenNameActive && (
                    <div className={`form-row inline row ${errors["motherMaidenName"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-mothers-maiden-name">{tLang("additionalInformationWidget.label.mothersMaidenName")}</label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <input
                                aria-required="true"
                                type="text"
                                className="inputbox"
                                id="label-mothers-maiden-name"
                                placeholder={tLang("additionalInformationWidget.placeholder.mothersMaidenName")}
                                name="motherMaidenName"
                                ref={register({ pattern: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\']+$/ })}
                            />
                            {!!errors["motherMaidenName"] && !!errors["motherMaidenName"] && errors["motherMaidenName"]!.type === "required" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.motherMaidenRequired")}</span>
                            )}
                            {!!errors["motherMaidenName"] && !!errors["motherMaidenName"] && errors["motherMaidenName"]!.type === "pattern" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.motherMaidenPattern")}</span>
                            )}
                        </div>
                    </div>
                )}

                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li onClick={() => setStatus(false)}>
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border btn-min-width">
                                    <span className="btn-text">{tLang("additionalInformationWidget.cancelButtonText")}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                    <span className="btn-text">{tLang("additionalInformationWidget.saveButtonText")}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AdditionalInfoForm;
